var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdl-textfield',{attrs:{"field-id":"signatureTyped","label":"Your Signature","bvalue":_vm.signature,"placeholder":"Type here to sign","show-chars-limit":true,"char-limit":"30","is-cursive":true},on:{"inputting":_vm.updateSignature}}),_vm._v(" "),_c('canvas',{attrs:{"id":"cvs","height":"50"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f27db284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignaturePad.vue
// module id = yfI3
// module chunks = 1